var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { useMobile } from '../hooks/use-mobile';
export var Video = function Video(props) {
  var className = props.className,
    src = props.src,
    videoProps = __rest(props, ["className", "src"]);
  var mobile = useMobile();
  return _jsx("video", Object.assign({}, videoProps, {
    className: classNames(className),
    src: mobile ? src === null || src === void 0 ? void 0 : src.mobile.path : src === null || src === void 0 ? void 0 : src.web.path
  }), mobile ? 'mobile' : 'web');
};